import { z } from 'zod';
import { IdeaStatus } from './idea.dto';

export const CompletionEventSchema = z.object({
  id: z.number(),
  ideaId: z.number(),
  ideaStatus: z.nativeEnum(IdeaStatus),
  title: z.string(),
  voteCount: z.number(),
  productAreas: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    }),
  ),
  ownerId: z.string(),
  completionSource: z.string(),
  completedAt: z.coerce.date(),
  viewedAt: z.coerce.date().nullable(),
  completedItemCount: z.number(),
  totalLinkedItemCount: z.number(),
  completionPercentage: z.number(),
  notificationStatus: z.enum(['DRAFT', 'SENT']).nullable(),
});

export type CompletionEventDto = z.infer<typeof CompletionEventSchema>;

export const GetCompletionEventsResponseSchema = z.array(CompletionEventSchema);
export type GetCompletionEventsResponseDto = z.infer<typeof GetCompletionEventsResponseSchema>;
